<template>
    <div id="wrapper" :key="valuekey">
          <div class="content-page">
              <div class="content">
                  <div class="container-fluid">
                      <!-- Form row -->
                      <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.menu.crud.user.label.title')}}</h4>

                            </div>
                        </div>
                       </div>
                      <div class="row">
                          <div class="col-md-12">
                              <div class="card-box">
                                      <div class="form-row" >
                                          <div class="form-group col-md-6">
                                              <label for="inputAddress" class="col-form-label">
                                                  {{$t('string.msg.list.user.label.name')}}
                                              </label>
                                              <input type="text" v-model="data.firstName" class="form-control">
                                          </div>
                                          <div class="form-group col-md-6">
                                              <label for="inputAddress" class="col-form-label">
                                                  {{$t('string.msg.list.user.label.lastname')}}
                                              </label>
                                              <input type="text" v-model="data.lastName" class="form-control">
                                          </div>
                                       </div>
                                       <div class="form-row" >
                                           <div class="form-group col-md-6">
                                              <label for="inputAddress" class="col-form-label">
                                                  {{$t('string.msg.menu.crud.user.label.access.email')}}
                                              </label>
                                              <input type="text" v-model="data.email" class="form-control" readonly=“true”>
                                          </div>
                                       </div>
                                       <div class="form-row">
                                           <div class="form-group col-md-3">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.list.user.label.new.password')}}
                                            </label>
                                            <input type="text" v-model="newPassword" class="form-control" :placeholder="toUpperCase($t('string.msg.user.type.new.password.placeholder'))" >
                                        </div>
                                        <div class="form-group col-md-2">
                                            <br>
                                            <br>
                                            <button v-on:click="checkForm2" class="text-dark-gray btn btn-warning w-100">{{$t('string.msg.status.change')}}</button>
                                        </div>
                                       </div>    
                                        <div class="form-row">
                                           <div class="form-group col-md-3">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.list.user.label.new.email')}}
                                            </label>
                                            <input type="text" v-model="newEmail" class="form-control" :placeholder="toUpperCase($t('string.msg.user.type.new.email.placeholder'))" >
                                        </div>
                                        <div class="form-group col-md-2">
                                            <br>
                                            <br>
                                            <button v-on:click="checkForm3" class="text-dark-gray btn btn-warning w-100">{{$t('string.msg.status.change')}}</button>
                                        </div>
                                       </div> 
                                       
                                    <div class="form-group col-md-6">
                                        <br><br>
                                        <button @click="addUser" class="btn btn-warning w-100 text-dark-gray">{{$t('string.msg.form.btn.add.new.user')}}</button>
                                    </div>
                                    <div>   
                                        <br> 
                                        <div v-show="formCrud== 'show'" class="form=row">
                                            <div class="form-row" >
                                                <div class="form-group col-md-6">
                                                    <label for="inputAddress" class="col-form-label">
                                                        {{$t('string.msg.form.crud.user.label.name')}}
                                                    </label>
                                                    <input type="text" v-model="newData.firstName" :placeholder="$t('string.msg.form.crud.user.placeholder.name')" class="form-control">
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label for="inputAddress" class="col-form-label">
                                                        {{$t('string.msg.form.crud.user.label.lastname')}}
                                                    </label>
                                                    <input type="text" v-model="newData.lastName" :placeholder="$t('string.msg.form.crud.user.placeholder.lastname')" class="form-control">
                                                </div>
                                            </div>
                                            <div class="form-row" >
                                                <div class="form-group col-md-6">
                                                    <label for="inputAddress" class="col-form-label">
                                                        {{$t('string.msg.form.crud.user.label.email')}}
                                                    </label>
                                                    <input type="text" v-model="newData.email" :placeholder="$t('string.msg.form.crud.user.placeholder.email')" class="form-control">
                                                </div>

                                                <div class="form-group col-md-6">
                                                    <label for="inputAddress" class="col-form-label">
                                                        {{$t('string.msg.form.crud.user.label.password')}}
                                                    </label>
                                                    <input type="text" v-model="newData.password" :placeholder="$t('string.msg.form.crud.user.placeholder.password')" class="form-control">
                                                </div>
                                       
                                            </div> 
                                            <br>
                                            <div class="d-flex justify-content-between bd-highlight">
                                                <button @click="cancelAdd" class="btn btn-secondary w-20">{{$t('string.msg.btn.cancel.add.user')}}</button>
                                                <button @click="save" class="btn btn-danger w-20">{{$t('string.msg.form.btn.save')}}</button>
                                            </div>
                                        </div>
                                        <br>
                                          <div class="table-responsive" v-if="data && data.companyUser && filters.companyId && data.companyUser.subtype == 'ADMIN_MASTER'">
                                             <table class="table table-centered table-hover mb-0"> 
                                                <thead   >
                                                    <tr>
                                                        <th scope="col">{{$t('string.msg.menu.crud.user.table.label.name')}}</th>
                                                        <th scope="col">{{$t('string.msg.menu.crud.user.table.label.email')}}</th>
                                                        <!--<th scope="col">{{$t('string.msg.menu.crud.user.table.label.remove')}}</th>-->
                                                    </tr>
                                                </thead>
                                                    <tbody v-bind:key="item._id" v-for="item in users" class="cursor-pointer">
                                                        <tr>
                                                            <td>
                                                                <span>
                                                                    {{toUpperCase(item.firstName) + ' ' + toUpperCase(item.lastName) }}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span>
                                                                    {{(item.email)}}
                                                                </span>
                                                            </td>
                                                            <!--<td><button  class="btn btn-danger w-20">X</button></td>-->
                                                        </tr>
                                                    </tbody>
                                                 </table>
                                          </div>
                                    </div>
                                     <div v-if="errors.length" class="alert alert-danger">
                                        <p class="lead">{{$t('response.msg.error.empty.fields')}}</p>
                                        <ul>
                                            <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                  </div>
              </div>
          </div>
          <Spinner />
          <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
          <Confirmation :title="titleToast" :message="messageToast" :cancelText="cancelText" :yesText="yesText" v-on:confirmation-return="save"/>
      </div>
</template>

<script>
import Controller from './CrtUser';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';

export default {
  name: 'User',
  components: {
    Spinner,
    Toast,
  },
  data() {
      return {
        errors: [],
        valuekey: 0,
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        users: [],
        newPassword: null,
        newEmail: null,
        formCrud: null,
        items: null,
        newData: {
            status: "ACTIVE",
            firstName: null,
            lastName: null,
            email: null,
            password: null,
            type: "USER-COMPANY",
            companyUser:{
                company:null,
               subtype: "ADMIN"
            }
        },
        data: {

        },
        filters: {
        name: "",
        isHideDetailsManufecturerFamily: true,
        isHideDetailsCompany: true,
        companyId: null
        },
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
  },
  mounted(){
      this.findAllUser();
  }
}
</script>


<style>
</style>
